'use client';

import MainMap from '../../components/Maps/components/MainMap';
import { MapDrawer } from './components/MapDrawer/MapDrawer';
import { MapMenu } from './components/MapMenu/MapMenu';
import { useExplore } from './context/ExploreContext';
import { useGeolocation } from '../../contexts/GeolocationContext/GeolocationContext';

export const Explore = () => {
  const { exploreQueryParams } = useExplore();
  const { drawerView } = exploreQueryParams;
  const isDrawerOpened = drawerView !== undefined;
  const { isLoading } = useGeolocation();

  return (
    <>
      <div
        className={`fixed top-0 left-0 flex min-h-full w-full pt-(--main-navigation-height-mobile) sm:z-auto sm:pt-(--main-navigation-height) ${
          isDrawerOpened ? 'z-modal' : ''
        }`}
      >
        <div className="flex grow flex-col sm:flex-row-reverse">
          <div className="flex grow">{isLoading ? <></> : <MainMap />}</div>
          {isDrawerOpened && (
            <div className="flex w-full sm:relative sm:w-[375px]">
              <div>
                <div className="z-modal bg-lake-fog scrollbar-none absolute top-32 bottom-0 left-0 w-full overflow-y-auto rounded-t-lg sm:top-0 sm:z-auto sm:w-[375px]">
                  <MapDrawer />
                </div>
              </div>
            </div>
          )}
          <MapMenu />
        </div>
      </div>
    </>
  );
};
